import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ClipboardCheck, Droplets, Plus, Trash2 } from "lucide-react";

const card = "rounded-2xl border border-card2-border bg-card2 p-5 space-y-3";
const title = "flex items-center gap-2 font-display text-lg font-bold uppercase text-zinc-100";

export function InspectionItemsCard() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/inspection-items").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, []);
  const save = async () => {
    try { const { data } = await api.put("/shop-settings/inspection-items", { items }); setItems(data.items); toast.success("Itens da vistoria salvos"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  if (!items) return null;
  return (
    <section data-testid="inspection-items-card" className={card}>
      <h2 className={title}><ClipboardCheck className="h-4 w-4 text-green-brand" /> Itens da vistoria de entrada</h2>
      {items.map((it, i) => (
        <div key={i} className="flex gap-2">
          <Input data-testid={`insp-item-${i}`} value={it} onChange={(e) => setItems((p) => p.map((x, j) => (j === i ? e.target.value : x)))} className="bg-zinc-900 border-zinc-800" />
          <button type="button" onClick={() => setItems((p) => p.filter((_, j) => j !== i))} className="text-red-400 px-2" aria-label="Remover"><Trash2 className="h-4 w-4" /></button>
        </div>
      ))}
      <div className="flex gap-2">
        <Button data-testid="insp-item-add" size="sm" variant="outline" onClick={() => setItems((p) => [...p, ""])} className="bg-zinc-900 border-zinc-800"><Plus className="h-4 w-4 mr-1" /> Item</Button>
        <Button data-testid="insp-items-save" size="sm" onClick={save} className="bg-green-brand text-white font-bold">Salvar itens</Button>
      </div>
    </section>
  );
}

export function OilSettingsCard({ shop, onSaved }) {
  const [f, setF] = useState({ interval_km: shop?.oil?.interval_km || 10000, interval_months: shop?.oil?.interval_months || 6 });
  const save = async () => {
    try { await api.put("/shop-settings/oil", { interval_km: Number(f.interval_km), interval_months: Number(f.interval_months) }); toast.success("Intervalo salvo"); onSaved?.(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <section data-testid="oil-settings-card" className={card}>
      <h2 className={title}><Droplets className="h-4 w-4 text-green-brand" /> Troca de óleo (padrão)</h2>
      <div className="flex flex-wrap gap-3 items-end">
        <label className="text-[11px] text-zinc-400">A cada (km)<Input data-testid="oil-cfg-km" type="number" value={f.interval_km} onChange={(e) => setF((p) => ({ ...p, interval_km: e.target.value }))} className="mt-1 w-32 bg-zinc-900 border-zinc-800" /></label>
        <label className="text-[11px] text-zinc-400">ou meses<Input data-testid="oil-cfg-months" type="number" value={f.interval_months} onChange={(e) => setF((p) => ({ ...p, interval_months: e.target.value }))} className="mt-1 w-24 bg-zinc-900 border-zinc-800" /></label>
        <Button data-testid="oil-cfg-save" size="sm" onClick={save} className="bg-green-brand text-white font-bold">Salvar</Button>
      </div>
      <p className="text-[11px] text-zinc-500">A próxima troca é estimada pela média de km/dia do veículo nesta oficina (ou 1.000 km/mês se não houver histórico), ou pela data — o que vier primeiro.</p>
    </section>
  );
}
